module.exports = __webpack_public_path__ + "static/media/WtbBannerMobile.bd0f1815.jpg";